function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u5F62\u72B6");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u804A\\u5929\\u914D\\u7F6E",
  transform: "translate(-732.000000, -244.000000)",
  fill: "#595959"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-11",
  transform: "translate(366.000000, 113.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-6",
  transform: "translate(306.666667, 131.000000)"
}, React.createElement("g", {
  id: "\\u5F62\\u72B6-2",
  transform: "translate(60.000000, 0.000000)"
}, React.createElement("path", {
  d: "M8,-8.97060204e-14 C12.418278,-8.97060204e-14 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,-8.97060204e-14 8,-8.97060204e-14 Z M8,1.26315789 C4.27934484,1.26315789 1.26315789,4.27934484 1.26315789,8 C1.26315789,11.7206552 4.27934484,14.7368421 8,14.7368421 C11.7206552,14.7368421 14.7368421,11.7206552 14.7368421,8 C14.7368421,4.27934484 11.7206552,1.26315789 8,1.26315789 Z M8.20757097,11.3687118 C8.61451762,11.3687118 8.94441307,11.6986072 8.94441307,12.1055539 C8.94441307,12.5125005 8.61451762,12.842396 8.20757097,12.842396 C7.80062431,12.842396 7.47072886,12.5125005 7.47072886,12.1055539 C7.47072886,11.6986072 7.80062431,11.3687118 8.20757097,11.3687118 Z M8.13078376,3.07972691 C9.77450998,3.07972691 11.0024022,4.13339178 11.0024022,5.7564023 C11.0024022,6.58081832 10.6703308,7.10533977 9.90045267,7.86192432 C9.81160067,7.94890431 9.81160067,7.94890431 9.72493184,8.03350694 C9.10173983,8.64334401 8.8640889,8.99401248 8.83121474,9.49669918 L8.82715778,9.62577586 L8.82715778,10.0851263 C8.82715778,10.4339377 8.54439025,10.7167053 8.19557883,10.7167053 C7.88164855,10.7167053 7.62121383,10.4876636 7.57226618,10.1875717 L7.56399988,10.0851263 L7.56399988,9.62577586 C7.56399988,8.61706825 7.94351426,8.00941115 8.84147027,7.13069826 C8.9300393,7.04423751 8.9300393,7.04423751 9.01507728,6.96099241 C9.56142433,6.42407922 9.73924433,6.14320468 9.73924433,5.7564023 C9.73924433,4.8775795 9.11613589,4.3428848 8.13078376,4.3428848 C7.10088314,4.3428848 6.51876665,5.1319742 6.52628091,5.84692168 C6.52994679,6.19571384 6.25016667,6.48143753 5.90137451,6.48510342 C5.55258235,6.4887693 5.26685866,6.20898917 5.26319278,5.86019702 C5.24900025,4.50984287 6.3040063,3.07972691 8.13078376,3.07972691 Z",
  id: "\\u5F62\\u72B6"
}))))));

var SvgToolTip = function SvgToolTip(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgToolTip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/toolTip.69283cae.svg";
export { ForwardRef as ReactComponent };